// ¿Es una ruta de esta app, segura para navegar? Absoluta (una sola barra inicial),
// sin `//host` ni `/\host` (el navegador los resuelve como otro origen) y sin
// caracteres de control: el parser de URL descarta tabs y saltos de línea, así que
// "/\t/evil.com" terminaría siendo "//evil.com". Fuente única para todo `to`/href
// que venga de datos (state de navegación, avisos del servidor).

function hasControlChar(s: string): boolean {
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    if (c <= 0x1f || c === 0x7f) {
      return true;
    }
  }
  return false;
}

export function isInternalPath(path: string): boolean {
  return /^\/(?![/\\])/.test(path) && !hasControlChar(path);
}
